<div [ngClass]="{ 'well': displayWell }">
    <validation-results [validationResults]="validationResults" *ngIf="showValidationComponent"></validation-results>
    <ng-container *ngIf="customerAccounts && customerAccounts">

        <h2>Accounts <button class="icon--add btn--default" type="button" *ngIf="!hideActions" (click)="popupAccountCreationModal()">Add Account</button></h2>
        <p-table styleClass="p-datatable-striped" [value]="customerAccounts">
            <ng-template pTemplate="header">
                <tr>
                    <th *ngFor="let column of columnData" [ngClass]="{'w--icon text-center': column.field == ''}">
                        {{column.header}}
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-data>
                <tr>
                    <td><span class="account--selector__name">{{data.accountName}}</span> ({{data.customerAccountNumberId}})</td>
                    <td><span class="account--selector__status" *ngIf="data.accountStatus"><i class="fa fa-circle fa-fw status-{{data.accountStatus}}" title="{{data.accountStatus}}"></i> {{data.accountStatus}}</span></td>
                    <td><span class="account--selector__type--{{data.accountType}}">{{data.accountType}}</span></td>
                    <td><span class="account--selector__balance pull-right">{{data.accountBalance | currency:'USD' }}</span></td>
                    <td *ngIf="!hideActions" class="text-center"><a class="icon--view" title="View Account" href="javascript:void(0)" (click)="handleAccountClick(data.customerAccountNumberId)"></a></td>
                </tr>
            </ng-template>
        </p-table>
    </ng-container>
</div>